import { css } from "@compiled/react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";

import { templatePreviewContentfulRelayFragment$key } from "@/__generated_contentful__/templatePreviewContentfulRelayFragment.graphql";
import { TemplatePreviewWindow } from "@/components/confluence/templates/template-preview-window";
import { TemplateType } from "@/content/templates/template.types";

interface TemplatePreviewProps {
    template: templatePreviewContentfulRelayFragment$key;
}

const WHITEBOARD_TEMPLATE_ID = "1HlskYfRNciSnQ02SDhCPs";

const templatePreviewSection = css({
    paddingBlockEnd: 16,
    textAlign: "center"
});

const previewBackgroundContainer = css({
    position: "relative",
    paddingBlockEnd: 48,
    paddingInlineEnd: 20,
    paddingInlineStart: 20
});

const relativePosition = css({
    "position": "relative",
    "margin": "0 auto",

    "@media (max-width: 39.99rem)": {
        maxWidth: 288
    },
    "@media (min-width: 40rem) and (max-width: 767.99px)": {
        maxWidth: 568
    },
    "@media (min-width: 768px) and (max-width: 1023.99px)": {
        maxWidth: 688
    },
    "@media (min-width: 1024px) and (max-width: 1279.99px)": {
        maxWidth: 648
    }
});

const TemplatePreviewRelayFragment = graphql`
    fragment templatePreviewContentfulRelayFragment on ProductTemplate {
        templateNameExternal
        templateTypeCollection {
            items {
                sys {
                    id
                }
            }
        }
        templatePreviews: templatePreviewCollection {
            items {
                url
            }
        }
    }
`;

export const TemplatePreview = ({ template }: TemplatePreviewProps) => {
    const { templateNameExternal, templateTypeCollection, templatePreviews } =
        useFragment(TemplatePreviewRelayFragment, template);

    const templatePreview = templatePreviews?.items[0] ?? null;

    if (!templatePreview) {
        return null;
    }

    return (
        <section css={[templatePreviewSection]}>
            {templatePreview && (
                <div css={[previewBackgroundContainer]}>
                    <div css={relativePosition}>
                        <TemplatePreviewWindow
                            url={templatePreview.url || ""}
                            alt={templateNameExternal ?? ""}
                            templateType={
                                templateTypeCollection?.items[0]?.sys?.id ===
                                WHITEBOARD_TEMPLATE_ID
                                    ? TemplateType.Whiteboard
                                    : TemplateType.Page
                            }
                        />
                    </div>
                </div>
            )}
        </section>
    );
};
